module.exports = __webpack_public_path__ + "img/re.01944ef9.jpg";